import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { IconLabelSwitch } from "../iconSwitch/IconLabelSwitch";

const useStyles = makeStyles((theme) => ({
    fillContainer: {
        minWidth: "100%",
    },
    center: {
        alignSelf: "center",
    },
    icon: {
        paddingTop: "5px",
    }
}));

const DefaultRadioButton = ({ defaultValue, control, onChange, value, name, error, center, list, disabled }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <FormControl
            variant="outlined"
            className={classes.fillContainer}
            size="small"
            error={error}
        >
            <Controller
                as={
                    <div className={(center ? (classes.center) : null)}>
                        <div>
                            <IconLabelSwitch name={t(name)} />
                        </div>
                        <div>
                            <RadioGroup
                                name={name}
                                value={value}
                                onChange={onChange}
                                row={true}
                                style={{paddingLeft: 10}}
                            >
                                {list.map((item) => {
                                    return (
                                        <FormControlLabel
                                            disabled={disabled ? disabled : (item.disabled ? item.disabled : null)}
                                            value={item.value}
                                            control={<Radio />}
                                            label={item.icon ? <IconLabelSwitch name={item.icon} /> : <IconLabelSwitch labelName={t(item.text)} />}
                                        />
                                    )
                                })}
                            </RadioGroup>
                        </div>
                    </div>
                }
                name={name}
                control={control}
                defaultValue={defaultValue}
            />
        </FormControl>
    );
};

export default DefaultRadioButton;
